<customer-wrapper>
    <ng-container main-content>
        <div class="form-subsection-container custom-page-row">
            <div class="page-title customer-form-title">
                <div>New Customer</div>
            </div>
            <button mat-stroked-button class="default-custom-button" (click)="toggleNotificationsModal()">
                <div class="custom-box-inner icon-button-inner">
                    <div class="icon-wrapper">
                    <img src="assets/icons/mark_email_unread.svg">
                    </div>
                    <div class="custom-box-text">Setup Notifications</div>
                </div>
            </button>
        </div>
        <customer-form [form]="form"/>
        <div class="customer-add-actions">
            <button mat-stroked-button routerLink="../" class="default-custom-button">Cancel</button>
            <button mat-flat-button class="add-button" [disabled]="!form?.valid" (click)="submitForm()">Add Customer</button>
        </div>

        <ng-container *ngIf="isConfiguringNotifications == true">
            <notification-setup-modal (close)="modalClosed()"/>
        </ng-container>
    </ng-container>
</customer-wrapper>
